export const updateProzorDimenzije = (setProzorDimenzije:any) => {
    setProzorDimenzije({
        vidljivaSirina: window.innerWidth,
        vidljivaVisina: window.innerHeight,
        preglednikSirina: window.outerWidth,
        preglednikVisina: window.outerHeight,
        ukupnaSirina: document.documentElement.scrollWidth,
        ukupnaVisina: document.documentElement.scrollHeight
    });
};

export function resizeProzorDimenzije(prozorDimenzije: any) {
    window.ProzorDimenzije=prozorDimenzije;

    document.documentElement.style.setProperty("--prozor-dimenzije-vidljiva-sirina", prozorDimenzije.vidljivaSirina+"px");
    document.documentElement.style.setProperty("--prozor-dimenzije-vidljiva-visina", prozorDimenzije.vidljivaVisina+"px");
    document.documentElement.style.setProperty("--prozor-dimenzije-preglednik-sirina", prozorDimenzije.preglednikSirina+"px");
    document.documentElement.style.setProperty("--prozor-dimenzije-preglednik-visina", prozorDimenzije.preglednikVisina+"px");
    document.documentElement.style.setProperty("--prozor-dimenzije-ukupna-sirina", prozorDimenzije.ukupnaSirina+"px");
    document.documentElement.style.setProperty("--prozor-dimenzije-ukupna-visina", prozorDimenzije.ukupnaVisina+"px");
}